import { z } from 'zod';
import { nameSchema, objectIdSchema, phoneSchema } from '../../validation';
import { partySchema } from '../../common';

export const vehicleDriverSchema = z.object({
  name: nameSchema,
  phone: phoneSchema,
  /**
   * the user id coming from User collection
   *
   * if empty, then it means the driver has not signed up yet
   * */
  userId: objectIdSchema.optional(),
  /**
   * the driver id coming Driver collection.
   */
  driverId: objectIdSchema,

  /**
   * the organization that a driver belongs to.
   *
   * if exists, then it means the driver belongs to an organization... most likely a `carrier_company`
   *
   * if null, then it means the driver is freelancer
   */
  org: partySchema.optional(),
});
export type VehicleDriver = z.infer<typeof vehicleDriverSchema>;
